module.exports = __webpack_public_path__ + "media/anime-scene.a828cb3b.mp4";